import styled from "styled-components"

export const DonationCheckboxContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  width: 100%;
`

export const DonationCheckboxLabel = styled.label`
  font-size: var(--font-size-sm);
  width: fit-content;
  margin-left: 10px;
  margin-right: auto;
  color: var(--color-order-detail-subtext);
`